import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=b87853f4&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Main.vue?vue&type=style&index=1&id=b87853f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87853f4",
  null
  
)

export default component.exports